import * as React from "react";
import { Loader2 } from "lucide-react";
import { Button, type ButtonProps } from "@/components/ui/button";

export interface LoadingButtonProps extends ButtonProps {
  /** Shows spinner and disables button */
  loading?: boolean;
  /** Text shown while loading (defaults to children) */
  loadingText?: string;
}

/**
 * Button with built-in loading spinner and disabled state.
 * Drop-in replacement for Button in async actions.
 */
const LoadingButton = React.forwardRef<HTMLButtonElement, LoadingButtonProps>(
  ({ loading = false, loadingText, disabled, children, ...props }, ref) => (
    <Button ref={ref} disabled={disabled || loading} {...props}>
      {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {loading && loadingText ? loadingText : children}
    </Button>
  )
);
LoadingButton.displayName = "LoadingButton";

export { LoadingButton };
